import { put, takeEvery } from "@redux-saga/core/effects";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
	cancelCreditRequest: "[cancelCreditRequest] Action",
	cancelCreditRequestLoad: "[cancelCreditRequestLoad] Action",
	cancelCreditRequestAsync: "[cancelCreditRequestAsync] Action",
};

const initialState = {
	data: [],
	loading: false,
};

export const cancel_credit_request_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.cancelCreditRequest:
			return {
				...state,
				data: payload ? payload : [],
			};

		case actionTypes.cancelCreditRequestLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({ type: actionTypes.cancelCreditRequestLoad, payload: true });
	let config = {
		url: "update_request",
	};

	let data = {
		table: "credit",
		method_type: "cancel_credit_request",
		data: payload?.data ? payload?.data : {},
		sort_by: {},
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		yield put({
			type: actionTypes.cancelCreditRequest,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({ type: actionTypes.cancelCreditRequestLoad, payload: false });
	}
}

export function* cancelCreditRequest() {
	yield takeEvery(actionTypes.cancelCreditRequestAsync, handleWorker);
}
